import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';
import { ListResponseAPI } from 'src/lib/queries';
import { BillingRun, BILLING_RUN_STATUS, BILLING_RUN_TYPE } from 'src/features/billingRuns/utils/types';

const RESOURCE = '/charges/billing-run/';

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    type?: BILLING_RUN_TYPE[];
    status?: BILLING_RUN_STATUS[];
    /** Plain YYYY-MM-DD, not a datetime. */
    business_date_after?: string;
    business_date_before?: string;
}

const queryFn = ({ ...params }: DTO): Promise<ListResponseAPI<BillingRun>> => {
    return axios.get(formatResourcePath(RESOURCE), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_BILLING_RUNS_RESOURCE, useQueryHook as useListBillingRuns };
